/* eslint-disable react/no-unknown-property */
import { Roboto, Nunito_Sans } from '@next/font/google';
import localFont from '@next/font/local';

export const defaultFont = Nunito_Sans({
    variable: '--font-family',
    weight: ['300', '400', '600', '700'],
    subsets: ['latin'],
    display: 'swap'
}); // change main font

export const officeFont = Nunito_Sans({
    variable: '--font-family',
    weight: ['300', '400', '600', '700'],
    subsets: ['latin'],
    display: 'swap'
}); // change office font

export const adminFont = Roboto({
    variable: '--font-family',
    weight: ['400', '500', '700'],
    subsets: ['latin'],
    display: 'swap'
}); // change admin font

export const prataFont = localFont({
    src: '../fonts/Prata-Regular.woff2',
    variable: '--font-prata',
    display: 'swap'
});

const FontStyle = ({ fontFamily }) => {
    return (
        <style jsx global>{`
            html {
                --font-family: ${fontFamily}, sans-serif;
            }
            html,
            button,
            input,
            select,
            textarea {
                font-family: ${fontFamily}, sans-serif;
            }
        `}</style>
    );
};
export const DefaultFontStyle = () => {
    return <FontStyle fontFamily={defaultFont.style.fontFamily} />;
};
export const OfficeFontStyle = () => {
    return <FontStyle fontFamily={officeFont.style.fontFamily} />;
};
export const AdminFontStyle = () => {
    return <FontStyle fontFamily={adminFont.style.fontFamily} />;
};
export const PrataFontStyle = () => (
    <style jsx global>{`
        :root {
            --font-prata: ${prataFont.style.fontFamily};
        }
    `}</style>
);
